* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.quarantine-form {
  padding-top: calc(var(--spacer) * 2);
  --form-field-label-width: 320px;
}

.tooltip-input-number {
  --tooltip-top: 0;
  --tooltip-left: 100%;
  --tooltip-transform: translateX(10px);
  pointer-events: inherit;
}

.quarantine-form {
  padding-top: calc(var(--spacer) * 2);
  --form-field-label-width: 320px;
}

.tooltip-input-number {
  --tooltip-top: 0;
  --tooltip-left: 100%;
  --tooltip-transform: translateX(10px);
}

.small-padding {
  padding-bottom: 0.1px;
}

#empty-state-add-button {
  padding-top: 5px;
}

gz-policy-panel-exchange-protection-anti-spoofing-grid {
  margin-top: -11px;
}

#exchange-protection-general-content {
  margin-bottom: 120px;
}
